import { useEffect, useState } from 'react'
import { applyTheme, readThemePreference, resolveTheme, storeThemePreference } from '../lib/theme'
import type { ThemePreference } from '../lib/theme'
import styles from './ThemeToggle.module.css'

const NEXT: Record<ThemePreference, ThemePreference> = {
    system: 'dark',
    dark: 'light',
    light: 'system',
}

const LABEL: Record<ThemePreference, string> = {
    system: 'auto',
    dark: 'dark',
    light: 'light',
}

export default function ThemeToggle() {
    const [pref, setPref] = useState<ThemePreference>(readThemePreference)

    useEffect(() => {
        applyTheme(pref)
        storeThemePreference(pref)
    }, [pref])

    const next = NEXT[pref]

    return (
        <button
            type="button"
            className={styles.toggle}
            onClick={() => setPref(next)}
            aria-label={`Theme: ${LABEL[pref]}. Switch to ${LABEL[next]}.`}
        >
            <span aria-hidden="true">{pref === 'system' ? '◐' : pref === 'dark' ? '●' : '○'}</span>
            <span className={styles.label}>{LABEL[pref]}</span>
        </button>
    )
}

export { resolveTheme }
